import { historyType, onClickPay, ServiceSubCategory, serviceType } from '@/commonTypes';
import PageCard from '@/components/general/PageCard';
import { avatarBg } from '@/functions/formats';
import MainIcons from '@/icons/main';
import React from 'react';
import styles from './styles.module.css';
import { useLayoutContext } from '@/context/LayoutContext';
import Button from '@/components/common/Button';
import { formatTehranPersianDate } from '@/functions/formatTehranPersianDate';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';

export default function LiveInquiry({
  data,
  onClickPay,
  lastHistoryInfo,
  subCategoryInfo,
  callBackHistory,
}: {
  data?: ServiceSubCategory;
  onClickPay?: onClickPay;
  lastHistoryInfo?: historyType;
  subCategoryInfo?: ServiceSubCategory;
  callBackHistory?: any;
}) {
  const { priceSymbol } = useLayoutContext();
  const feeText = '20,000';

  console.log('lastHistoryInfo', lastHistoryInfo);
  return (
    <div>
      <PageCard
        title={`استعلام لحظه‌ای راهور`}
        icon={<MainIcons.SampleIcon width="20px" height="20px" fill="var(--brand-deep)" />}
        text={
          <div className={styles.last}>
            <MainIcons.clockIcon width="13px" height="13px" />
            آخرین استعلام:{' '}
            {lastHistoryInfo?.created_at ? (
              <b dir="ltr">{formatTehranPersianDate(lastHistoryInfo?.created_at)}</b>
            ) : (
              '-'
            )}
          </div>
        }
        backgroundIcon={avatarBg(6)}
        className={`${styles.pageCard}`}
        iconClass={`${styles.iconClass}`}
        headClass={`${styles.headClass}`}
        aside={
          <div className={styles.right}>
            <span className={styles.fee}>
              <MainIcons.coinIcon />
              {`هزینهٔ استعلام`}:&nbsp;
              {/* <b>
                { subCategoryInfo?.price}</b> {priceSymbol} */}
              <PriceSection value={subCategoryInfo?.price} />
            </span>
            <Button
              className={` btn btn-primary squareButton ${styles.button}`}
              onClick={() => {
                onClickPay && onClickPay('inq', subCategoryInfo, callBackHistory);
              }}
            >
              <MainIcons.RefreshIcon fill="var(--paper)" width="16px" height="16px" />
              گرفتن استعلام
            </Button>
          </div>
        }
      ></PageCard>
    </div>
  );
}
